module.exports = __webpack_public_path__ + "img/header-engagementRingsDiamond@2x.7ace0e8.webp";